export interface DefaultCustomer {
  id?: string
  name?: string
  roles?: string[]
}

export interface Branding {
  logo?: string
}

export interface Customer {
  id?: string
  name?: string
  roles?: Role[]
  branding?: Branding
}

export interface WorkspaceSettings {
  defaultCustomer: DefaultCustomer
  lastAccessedCustomer: LastAccessedCustomer
  allowedCustomers: Customer[]
  lastActive?: Date
  developerMode?: boolean
  fraudTeamMember?: boolean
}

export enum Role {
  user = 'user',
  admin = 'admin',
  supervisor = 'supervisor',
  executive = 'executive',
  fraud = 'fraud',
  labResetResidential = 'lab_reset_residential',
  resetSection = 'reset_section',
}

interface LastAccessedCustomer {
  id: string
  roles?: Role[]
}

export interface UserData {
  id: string
  userId?: string
  name?: Name
  workspaceSettings?: WorkspaceSettings
  config?: Config
}

interface Name {
  firstname?: string
  lastname?: string
}

export interface Color {
  primaryActive?: string
  secondaryActive?: string
  primaryDisabled?: string
  mainHighlight?: string
  alternateBackground?: string
  mainBodyText?: string
  highlightBodyText?: string
  disabledBodyText?: string
  botAvatarImage?: string
}

export interface Theme {
  name?: string
  color?: Color
}

export interface Application {
  create?: boolean
  read?: boolean
  update?: boolean
  delete?: boolean
  decision?: boolean
}

export interface Subject {
  create?: boolean
  read?: boolean
  update?: boolean
  delete?: boolean
}

export interface Asset {
  create?: boolean
  read?: boolean
  update?: boolean
  delete?: boolean
}

export interface Permissions {
  application?: Application
  subject?: Subject
  asset?: Asset
}

export interface DashboardSettings {
  addGuarantorButton?: boolean
  navbarActivity?: boolean
  navbarInsights?: boolean
  navbarCommissions?: boolean
  hideTasksList?: boolean
  hideAgentBot?: boolean
}

export interface Config {
  themes?: Theme[]
  permissions?: Permissions
  dashboardSettings?: DashboardSettings
  automaticAcceptance?: boolean
}
